module.exports = __webpack_public_path__ + "media/images/grappe-6e25d50f4448dc4017ca742a9020643c.png";